import React, { useState, useEffect, useRef } from 'react';
import { WifiOff, RefreshCw } from 'lucide-react';
import { processPendingSyncs } from '../../utils/offlineSync';
import { updateServiceStatus } from '../DELIVERY/services/deliveryServices';

const SYNC_HANDLERS = {
  'UPDATE_SERVICE_STATUS': async (data) => {
    await updateServiceStatus(data.serviceId, data.status, data.driverUid);
  }
};

export const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const goOnline = () => setIsOnline(true);
    const goOffline = () => setIsOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return isOnline;
};

export const OfflineBanner = () => {
  const isOnline = useOnlineStatus();
  const [isSyncing, setIsSyncing] = useState(false);
  const wasOfflineRef = useRef(false);

  useEffect(() => {
    if (!isOnline) {
      wasOfflineRef.current = true;
      return;
    }
    if (!wasOfflineRef.current) return;
    wasOfflineRef.current = false;

    setIsSyncing(true);
    processPendingSyncs(SYNC_HANDLERS)
      .catch(console.error)
      .finally(() => setIsSyncing(false));
  }, [isOnline]);

  if (isOnline && !isSyncing) return null;

  if (isOnline && isSyncing) {
    return (
      <div
        role="status"
        aria-live="polite"
        data-testid="offline-banner"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          background: '#0ea5e9',
          color: '#fff',
          padding: '10px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          fontSize: '14px',
          fontWeight: 600,
          fontFamily: 'inherit',
          boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
        }}
      >
        <RefreshCw size={18} className="animate-spin" />
        Conexión restaurada — Sincronizando datos...
      </div>
    );
  }

  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="offline-banner"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: '#d97706',
        color: '#fff',
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        fontSize: '14px',
        fontWeight: 600,
        fontFamily: 'inherit',
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
      }}
    >
      <WifiOff size={18} />
      Modo Offline — Sincronizando datos localmente...
    </div>
  );
};

export default OfflineBanner;
